import Carriers from 'pages/ga/carriers/Index';
import CarriersAdd from 'pages/ga/carriers/Add';
import CarriersEdit from 'pages/ga/carriers/Edit';

const CarriersRoutes = [
    {
        index: true,
        element: <Carriers />,
    },
    {
        path: 'add',
        element: <CarriersAdd />,
        hidden: true,
    },
    {
        path: 'edit/:id',
        element: <CarriersEdit />,
        hidden: true,
    },
];

export default CarriersRoutes;
